function getApiUrl() {
    //return "http://localhost:1012/";
    return window.location.origin + "/api/";
}

export {getApiUrl};